import { WardrobeOutlineIcon } from './WardrobeOutlineIcon';

/**
 * author: GreenTurtwig
 * id A1AA70DE-C9FD-4791-91D0-27FC025F7A81
 * name wardrobe-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wardrobe-outline.svg
 * tags
 * - Home Automation 
 */
export const ClosetOutlineIcon = WardrobeOutlineIcon;
export default ClosetOutlineIcon